const map = {
	"./background-case-design.webp": 2009,
	"./background-case-e-commerce.webp": 27058,
	"./case-01.webp": 27331,
	"./case-02.webp": 19906,
	"./case-03.webp": 82925,
	"./case-04.webp": 3708,
	"./case-05.webp": 5247,
	"./case-06.webp": 8094,
	"./case-07.webp": 68985,
	"./case-08.webp": 80008,
	"./case-09.webp": 14251,
	"./case-13.webp": 54832
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76029;